import { c as _c } from "react/compiler-runtime";
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popper from '@mui/material/Popper';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { Children, cloneElement, forwardRef, isValidElement, useState, type FC, type KeyboardEvent, type MouseEvent as ReactMouseEvent, type ReactNode } from 'react';
interface PopperMenuProps {
  onMouseEnter?: (event: ReactMouseEvent<HTMLAnchorElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLAnchorElement>) => void;
  children: ReactNode;
  icon: ReactNode;
  label: string;
}
interface MenuChildProps {
  isMenuOpen?: boolean;
}
let closeActivePopper: (() => void) | null = null;
const PopperMenu = forwardRef<HTMLAnchorElement, PopperMenuProps>(function PopperMenu(t0, ref) {
  const $ = _c(49);
  let children;
  let icon;
  let label;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      icon,
      label,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = icon;
    $[3] = label;
    $[4] = props;
  } else {
    children = $[1];
    icon = $[2];
    label = $[3];
    props = $[4];
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  let t1;
  if ($[5] !== label || $[6] !== open) {
    t1 = open ? `side-menu-group-popper-${label.toLowerCase().replace(/ /g, "-")}` : undefined;
    $[5] = label;
    $[6] = open;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const id = t1;
  let handleClose;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    handleClose = () => {
      if (closeActivePopper === handleClose) {
        closeActivePopper = null;
      }
      setAnchorEl(null);
    };
    $[8] = handleClose;
  } else {
    handleClose = $[8];
  }
  let t2;
  if ($[9] !== props) {
    t2 = event => {
      closeActivePopper?.();
      closeActivePopper = handleClose;
      props.onMouseEnter?.(event);
      setAnchorEl(event.currentTarget);
    };
    $[9] = props;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const handleOpen = t2;
  let t3;
  if ($[11] !== children) {
    t3 = Children.map(children, _temp);
    $[11] = children;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const renderedChildren = t3;
  const t4 = open ? "true" : "false";
  let t5;
  if ($[13] !== props) {
    t5 = event_0 => {
      props.onKeyDown?.(event_0);
      if (event_0.key.match(/(ArrowLeft|ArrowRight|Tab)/)) {
        handleClose();
      }
    };
    $[13] = props;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event_1 => setAnchorEl(event_1.currentTarget);
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== handleOpen) {
    t7 = event_2 => {
      event_2.preventDefault();
      handleOpen(event_2);
    };
    $[16] = handleOpen;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== open) {
    t8 = theme => ({
      ...(open ? {
        backgroundColor: theme.palette.action.hover
      } : {}),
      minHeight: 55,
      justifyContent: "center",
      px: 2.5
    });
    $[18] = open;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== icon) {
    t9 = <ListItemIcon sx={_temp2}>{icon}</ListItemIcon>;
    $[20] = icon;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== handleOpen || $[23] !== props || $[24] !== ref || $[25] !== t4 || $[26] !== t5 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t10 = <ListItemButton component="a" aria-haspopup="menu" aria-expanded={t4} ref={ref} {...props} role="menuitem" onKeyDown={t5} onFocus={t6} onMouseEnter={handleOpen} onClick={t7} sx={t8}>{t9}</ListItemButton>;
    $[22] = handleOpen;
    $[23] = props;
    $[24] = ref;
    $[25] = t4;
    $[26] = t5;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  let t12;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      name: "offset",
      options: {
        offset: [8, 0]
      }
    };
    t12 = {
      name: "flip",
      enabled: false
    };
    $[31] = t11;
    $[32] = t12;
  } else {
    t11 = $[31];
    t12 = $[32];
  }
  let t13;
  let t14;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = [t11, t12, {
      name: "preventOverflow",
      options: {
        padding: 8,
        boundary: "viewport"
      }
    }];
    t14 = {
      zIndex: 9990
    };
    $[33] = t13;
    $[34] = t14;
  } else {
    t13 = $[33];
    t14 = $[34];
  }
  let t15;
  if ($[35] !== anchorEl) {
    t15 = () => setAnchorEl(anchorEl);
    $[35] = anchorEl;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== label || $[38] !== renderedChildren) {
    t16 = <List role="menu" aria-label={label} sx={_temp3}>{renderedChildren}</List>;
    $[37] = label;
    $[38] = renderedChildren;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== anchorEl || $[41] !== id || $[42] !== open || $[43] !== t15 || $[44] !== t16) {
    t17 = <Popper id={id} open={open} anchorEl={anchorEl} keepMounted={true} placement="right-start" modifiers={t13} sx={t14} onMouseEnter={t15} onMouseLeave={handleClose}>{t16}</Popper>;
    $[40] = anchorEl;
    $[41] = id;
    $[42] = open;
    $[43] = t15;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t10 || $[47] !== t17) {
    t18 = <ClickAwayListener onClickAway={handleClose}><Box>{t10}{t17}</Box></ClickAwayListener>;
    $[46] = t10;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
});
interface SideMenuGroupProps {
  isMenuOpen: boolean;
  icon: ReactNode;
  title: string;
  children: ReactNode;
}
export const SideMenuGroup: FC<SideMenuGroupProps> = t0 => {
  const $ = _c(19);
  const {
    isMenuOpen,
    icon,
    title,
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "block"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      popper: {
        modifiers: [{
          name: "offset",
          options: {
            offset: [0, -10]
          }
        }]
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== icon || $[4] !== isMenuOpen || $[5] !== isOpen || $[6] !== title) {
    t3 = isMenuOpen ? <ListItemButton sx={theme => ({
      minHeight: 55,
      justifyContent: isMenuOpen ? "initial" : "center",
      px: 2.5,
      backgroundColor: undefined,
      "&:hover": {
        backgroundColor: theme.palette.primary.altern
      }
    })} selected={isOpen} onClick={() => setIsOpen(!isOpen)}><ListItemIcon sx={t4 => {
        const {
          palette
        } = t4;
        return {
          minWidth: 0,
          mr: isMenuOpen ? 3 : "auto",
          justifyContent: "center",
          color: palette.getContrastText(palette.primary.main)
        };
      }}>{icon}</ListItemIcon><ListItemText sx={{
        opacity: isMenuOpen ? 1 : 0
      }} primaryTypographyProps={{
        fontWeight: 600,
        color: "white",
        fontSize: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1
      }}>{title}<KeyboardArrowDown sx={{
          transform: isOpen ? "initial" : "rotate(-90deg)",
          transition: "transform 120ms ease"
        }} /></ListItemText></ListItemButton> : <PopperMenu icon={icon} label={title}>{children}</PopperMenu>;
    $[2] = children;
    $[3] = icon;
    $[4] = isMenuOpen;
    $[5] = isOpen;
    $[6] = title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isMenuOpen || $[9] !== t3 || $[10] !== title) {
    t4 = <Tooltip title={title} placement="right" disableHoverListener={isMenuOpen} componentsProps={t2}>{t3}</Tooltip>;
    $[8] = isMenuOpen;
    $[9] = t3;
    $[10] = title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== children || $[13] !== isMenuOpen || $[14] !== isOpen) {
    t5 = isMenuOpen && isOpen && <List sx={{
      paddingLeft: "32px"
    }}>{children}</List>;
    $[12] = children;
    $[13] = isMenuOpen;
    $[14] = isOpen;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <ListItem disablePadding={true} sx={t1}>{t4}{t5}</ListItem>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
function _temp(child) {
  if (isValidElement(child)) {
    return cloneElement(child, {
      isMenuOpen: true
    });
  }
  return child;
}
function _temp2(t0) {
  const {
    palette
  } = t0;
  return {
    minWidth: 0,
    mr: "auto",
    justifyContent: "center",
    color: palette.getContrastText(palette.primary.main)
  };
}
function _temp3(theme_0) {
  return {
    my: -1,
    boxShadow: "md",
    borderRadius: "sm",
    minWidth: 180,
    backgroundColor: theme_0.palette.primary.main,
    color: theme_0.palette.getContrastText(theme_0.palette.primary.main),
    "--List-radius": "8px"
  };
}